const paths = {
  main: '/reset-password',
  thank: '/reset-password/thank',
  confirm: '/reset-password/confirm',
};

export default paths;
